<template>
    <ion-content fullscreen scroll-y="false">
        <h1>Page not found</h1>
        <ion-button @click="actions.goHome">
            Back
        </ion-button>
        <ion-fab v-if="checkMode === 'development'" class="admin_panel" vertical="center" horizontal="end" edge slot="fixed" style="bottom: 80px;" v-show="!false">
            <ion-fab-button>
                <i class="el-icon-s-tools"></i>
            </ion-fab-button>
            <ion-fab-list side="start">
                <ion-fab-button @click="actions.logOut" v-if="$store.getters.isAuthenticated">
                    <div class="ion-fab_text">
                        <span><i class="el-icon-circle-close"></i></span>
                        <span>Logout</span>
                    </div>
                </ion-fab-button>
                <ion-fab-button @click="actions.clearStorage">
                    <div class="ion-fab_text">
                        <span><i class="el-icon-delete-solid"></i></span>
                        <span>Clear local storage</span>
                    </div>
                </ion-fab-button>
                <ion-fab-button @click="actions.deleteUser" v-if="$store.getters.isAuthenticated">
                    <div class="ion-fab_text">
                        <span><i class="el-icon-close"></i></span>
                        <span>Delete user</span>
                    </div>
                </ion-fab-button>
                <ion-fab-button @click="actions.activateUser" v-if="$store.getters.isAuthenticated">
                    <div class="ion-fab_text">
                        <span><i class="el-icon-check"></i></span>
                        <span>Activate user</span>
                    </div>
                </ion-fab-button>
            </ion-fab-list>

            <ion-fab-list side="bottom">
                <ion-fab-button @click="actions.setAccountType" v-if="userRole">
                    <div class="ion-fab_text" v-if="userRole == 'locum'">
                        <span><i class="el-icon-s-cooperation"></i></span>
                        <span>Switch to Pharmacy</span>
                    </div>
                    <div class="ion-fab_text" v-else>
                        <span><i class="el-icon-s-custom"></i></span>
                        <span>Switch to Locum</span>
                    </div>
                </ion-fab-button>
                <ion-fab-button @click="actions.refreshPage">
                    <div class="ion-fab_text">
                        <span><i class="el-icon-refresh"></i></span>
                        <span>Refresh page</span>
                    </div>
                </ion-fab-button>
                <ion-fab-button @click="actions.getUserInfo" v-if="$store.getters.isAuthenticated">
                    <div class="ion-fab_text">
                        <span><i class="el-icon-info"></i></span>
                        <span>Get user info</span>
                    </div>
                </ion-fab-button>
            </ion-fab-list>
        </ion-fab>
    </ion-content>
</template>

<style lang="scss">
.admin_panel {
    bottom: unset !important;

    ion-fab-button {
        font-size: 10px;
        white-space: unset;

        width: 60px;
        height: 60px;

        &.ion-activatable {

            i {
                font-size: 24px;
            }
        }

        .ion-fab_text {
            display: flex !important;
            flex-direction: column !important;

            margin-top: -10px;
            padding: 3px;

            i {
                font-size: 14px;

                margin-bottom: 5px;
            }
        }
    }
}

</style>

<script>
    import {
        inject
    } from 'vue';
    import {
        IonContent,
        IonButton,
        IonFab,
        IonFabButton,
        IonFabList,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
    } from 'vue-router'

    export default {
        components: {
            IonContent,
            IonButton,
            IonFab,
            IonFabButton,
            IonFabList,

        },
        setup() {
            const $store = useStore()
            const $router = useRouter()

            const userData = $store.getters.GET_USER_DATA;
            const userRole = userData.role;
            const routerViewState = inject('routerViewState');
const checkMode = process.env.NODE_ENV;


            const actions = {
                refreshPage() {
                    $router.go(0);
                },
                clearStorage() {
                    localStorage.removeItem('vuex');
                    $router.go(0);
                },
                logOut() {
                    $store.dispatch('AUTH_LOGOUT')
                },
                setAccountType() {
                    userRole == 'locum' ? $store.dispatch('SET_USER_ROLE', 'pharmacy') : $store.dispatch('SET_USER_ROLE', 'locum')
                    routerViewState();
                    $router.go(0);
                },
                async deleteUser() {
                    try {
                        await $store.dispatch('DELETE_USER');
                        // $router.go(0);
                    } catch (error) {
                        console.log(error);
                    }
                },
                async activateUser() {
                    try {
                        await $store.dispatch('ACTIVATE_USER');
                    } catch (error) {
                        console.log(error);
                    }
                },
                async getUserInfo() {
                    try {
                        await $store.dispatch('SET_CURRENT_USER_DATA', {
                            with: 'settings,billingInfo'
                        });
                    } catch (error) {
                        console.log(error);
                    }
                },
                goHome() {
                    $router.push({
                        name: 'home'
                    })
                }
            }
            return {
                userRole,
                actions,
              checkMode
            }
        },
    };
</script>